const yt_launcher = $('.yt-launcher');

if (yt_launcher) {
  $(document).on('click', '.yt-launcher', function(event) {
    event.preventDefault();
    const yt_overlay = $(this).find('.video-overlay');
    const yt_iframe = $(this).find('.video-overlay-youtube');
    const yt_img = $(this).find('.yt-launcher-img');
    const sourceUrl = yt_iframe.data('src-cmplz') + '?rel=0&controls=1&showinfo=0&autoplay=1&mute=1';

    yt_iframe.attr('src', sourceUrl);
    yt_overlay.hide();
    yt_img.hide();
    yt_iframe.addClass('show');
  });
}
